import { useSearchParams } from "react-router-dom";

import { Paper, Stack, Typography } from "@mui/material";

import { MeetingJoinType } from "../../types";

import { ClearCallLogoTitle } from "../../components/clear-call-logo";
import MeetingSurveyPanel from "./components/meeting-survey-panel";

const MeetingLeftPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const meetingId = searchParams.get("meetingId") || "";
  const userId = searchParams.get("userId") || "";
  const joinCode = searchParams.get("joinCode") || "";
  const joinType = searchParams.get("joinType") || MeetingJoinType.Web;
  const isTraining = searchParams.get("isTraining") === "true";

  const isRealWareDevice =
    window.screen.width === 1003 && window.screen.height === 564;

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      aria-hidden={joinType === MeetingJoinType.Headset && isRealWareDevice}
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(0deg,rgb(222, 238, 253),rgb(172, 220, 226))",
      }}
    >
      {joinType === MeetingJoinType.Web ? (
        <MeetingSurveyPanel
          meetingId={meetingId}
          userId={userId}
          joinCode={joinCode}
        />
      ) : isTraining ? (
        <Paper
          elevation={20}
          sx={{
            width: 1000,
            p: 4,
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <Stack
            spacing={3}
            alignItems="center"
            justifyContent="center"
            sx={{ width: "100%", pt: 2 }}
          >
            <ClearCallLogoTitle size={150} />
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Typography variant="h6" align="center">
                You have left the training session
              </Typography>
              <Typography variant="body1" align="center">
                You can close this tab now.
              </Typography>
            </Stack>
          </Stack>
        </Paper>
      ) : joinType === MeetingJoinType.Headset ? (
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={4}
        >
          <ClearCallLogoTitle size={180} /> 
          <Typography variant="h4" align="center">
            You have left the call
          </Typography>
        </Stack>
      ) : (
        <Typography variant="h6" align="center">
          You have left the meeting
        </Typography>
      )}
    </Stack>
  );
};

export default MeetingLeftPage;
